// removed by extract-text-webpack-plugin
module.exports = {"publicsection":"wmf-3AUQyMXy","publlictitle":"wmf-3docs0n-","required":"wmf-2NxL9JEp","informationtitle":"wmf-3POrjLag","titles":"wmf-dx33fzOT","skustyle":"wmf-1Ms1QqbY"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/commoditymanagement/addcompleteinformation/nonmedicaldevices/no-nmedical-devices.module.less
// module id = 1051
// module chunks = 0